<template>
    <div class="course_login">
        <div class="course_login_page">
            <div class="navigation">
                <div class="left" @click="goToBack"><i class="icon-thin_back"></i></div>
                <div class="content">{{navTitle}}</div>
            </div>
            <div class="course_login_content">
                <div class="tabs">
                    <div v-bind:class="{'tab_message_login':true, 'selected_tab':selectedTab === 1}" @click="selectedTabClick(1)">短信登录/注册</div>
                    <div v-bind:class="{'tab_psw_login':true, 'selected_tab':selectedTab === 2}" @click="selectedTabClick(2)">密码登录</div>
                </div>
                <div v-if="selectedTab === 1" class="message_login">
                    <div class="mobile_phone">
                        <span class="select-code" @click="selectCodeClick">+{{countryTel}}</span>
                        <input id="textPhone" placeholder="手机号" type="text" value="">
                    </div>
                    <div class="verification_code">
                        <span class="add-on"><i class="fa icon-code"></i></span>
                        <input id="textVerificationCode" maxlength="6" placeholder="手机验证码" type="text" value="">
                        <a id="a_send_code" class="btn-up-resend js-send-code-button" @click="verificationCodeClick" href="javascript:void(0);">发送验证码</a>
                    </div>
                    <div class="btn_message_login" @click="loginClick">注册 / 登录</div>
                    <div class="agreement" @click="agreementClick">未注册手机验证后自动登录<br/>注册即代表你同意<span>《小花生使用协议》</span></div>
                </div>
                <div v-else class="psw_login">
                    <div class="user_name">
                        <span class="add-on"><i class="fa icon-user"></i></span>
                        <input id="textUserName"  placeholder="手机号 / 用户名" type="text" value="">
                    </div>
                    <div class="psw">
                        <span class="add-on"><i class="fa icon-password"></i></span>
                        <input id="textPSW"  placeholder="密码" type="password" value="">
                    </div>
                    <div class="btn_psw_login" @click="login2Click">登录</div>
                    <div class="btn_psw_bottom"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    import {Indicator, MessageBox, Toast} from 'mint-ui';
    let wait = 60;
    let timeResult;

    export default {
        name: 'login',
        data() {
            return {
                countryTel:"",
                selectedTab: 1,
                navTitle:"",
                redirectName:""
            }
        },
        created() {
            let that = this;
            that.redirectName = that.$router.currentRoute.query.redirect;
            that.countryTel = "86";
        },
        methods: {
            goToBack:function () {
                if (this.redirectName === "Home") {
                    this.$router.replace({name: "Home"})
                } else {
                    this.goBack(this.$router);
                }
            },
            selectCodeClick() {
                this.$router.push({path:'/selectCode', query: {tel: this.countryTel}});
            },
            judgePhoneNumber: function () {
                let vPhoneNumber = $.trim($("#textPhone").val());

                if (vPhoneNumber == null || vPhoneNumber.length === 0) {
                    Toast('请输入手机号码');
                    return false;
                }

                if (this.countryTel !== "86") {
                    return true;
                }

                var reg_phone = /^0?(13[0-9]|15[012356789]|18[0123456789]|14[57]|17[678]|170[059]|14[57]|166|19[89])[0-9]{8}$/;

                if (!reg_phone.test(vPhoneNumber)) {
                    Toast('手机号格式不正确');
                    return false;
                }

                return true;
            },
            judgeVerificationCode: function () {
                let vVerificationCode = $.trim($("#textVerificationCode").val());

                if (vVerificationCode == null || vVerificationCode.length === 0) {
                    Toast('请输入验证码');
                    return false;
                }

                return true;
            },
            sendsms: function () {
                let that = this;

                if (wait == 0) {
                    $("#a_send_code").removeClass("disable");
                    $("#a_send_code").html("重新发送");
                    wait = 60;
                } else {
                    $("#a_send_code").removeClass("disable").addClass("disable");
                    $("#a_send_code").html("重新发送(" + wait + ")");
                    wait--;
                    timeResult = setTimeout(function () {
                        that.sendsms();
                    }, 1000)
                }
            },
            selectedTabClick: function (tab) {
               let that = this;
                that.selectedTab = tab;
            },
            agreementClick:function () {
                this.$router.push({name: "agreement"})
            },
            verificationCodeClick:function () {
                let that = this;

                if(!that.judgePhoneNumber()) {
                    return;
                }

                that.sendsms();
                let vPhoneNumber = $.trim($("#textPhone").val());

                this.$axios.get("/my/sendSmsVerificationCode/" + vPhoneNumber + "/" + that.countryTel).then((response) => {
                    let vResult = response.data;

                    // 0失败/1成功
                    if (that.getCount(vResult) === 1) {
                        Toast('验证码已发送');
                    } else {
                        Toast('验证码发送失败');
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            loginClick:function () {
                let that = this;

                if(!that.judgePhoneNumber()) {
                    return;
                }

                if(!that.judgeVerificationCode()) {
                    return;
                }

                let vPhoneNumber = $.trim($("#textPhone").val());
                let vVerificationCode = $.trim($("#textVerificationCode").val());
                let vPhoneCode = that.countryTel;
                Indicator.open('登录中...');

                this.$axios.get("my/loginBySmsVerificationCodeForWeb/" + vPhoneNumber + "/" + vPhoneCode + "/" + vVerificationCode).then((response) => {
                    let vResult = that.getCount(response.data);
                    Indicator.close();

                    // -1验证码不正确/0未注册/大于0表示登录成功的用户ID
                    if (vResult === -1) {
                        Toast('验证码不正确');
                    } else if (vResult === 0) {
                        this.$router.push({name: "perfectinfo", query: {phoneNumber: vPhoneNumber, phoneCode: vPhoneCode}});
                        clearTimeout(timeResult);
                    } else if (vResult > 0) {
                        this.$store.dispatch('SetToken', vResult);
                        this.$store.dispatch('SetUserId', vResult);

                        this.goBack(this.$router);
                        clearTimeout(timeResult);
                    } else {
                        Toast('登录失败');
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            login2Click:function () {
                let that = this;

                let vUserName = $.trim($("#textUserName").val());
                let vPSW = $.trim($("#textPSW").val());

                if (that.isEmpty(vUserName)) {
                    Toast('请输入手机号或用户名');
                    return;
                }

                if (that.isEmpty(vPSW)) {
                    Toast('请输入密码');
                    return;
                }

                Indicator.open('登录中...');
                this.$axios.post("my/loginByPassword/",{
                    phoneOrName:vUserName,
                    password:vPSW
                }).then((response) => {
                    let vResult = that.getCount(response.data);
                    Indicator.close();

                    // -1系统异常/-2未注册/-3密码错误/大于0表示登录成功的用户ID
                    if (vResult === -2) {
                        MessageBox.confirm('', {
                            message: ' ',
                            title: '还未注册，请用短信验证码注册后再使用哦~',
                            showConfirmButton:false,
                            showCancelButton:true,
                            closeOnClickModal: false,
                            cancelButtonClass:'cancelButton',
                            confirmButtonClass:'confirmButton',
                            cancelButtonText:'知道了'
                        });
                    } else if (vResult === -3) {
                        Toast('密码错误');
                    } else if (vResult > 0) {
                        this.$store.dispatch('SetToken', vResult);
                        this.$store.dispatch('SetUserId', vResult);

                        this.goBack(this.$router);
                    } else {
                        Toast('系统异常，请重试');
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            }
        },
        mounted() {
            if (this.$route.query.tel) {
                let that = this;
                that.countryTel = this.$route.query.tel || 86;
            }
        }
    }
</script>
<style scoped>
    .course_login {
        position:absolute;
        width:100%;
        height:auto;
        min-height: 100%;
        text-align: center;
    }
    .course_login_page {
        position:absolute;
        max-width: 590px;
        background-color: white;
        width: 100%;
        height: 100%;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .navigation {
        width: 100%;
        height: 44px;
        position: fixed;
        border-bottom: 1px solid #E5E3E3;
        background-color: white;
        max-width: 590px;
    }
    .navigation .left {
        float: left;
        width: 50px;
        height: 100%;
        color: #333333;
        font-size: 20px;
        text-align: center;
        line-height: 50px;
    }
    .navigation .content {
        float: left;
        height: 100%;
        width: calc(100% - 50px - 15px);
        text-align: center;
        line-height: 44px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }
    .course_login_content {
        position: absolute;
        width: 300px;
        left: 50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .course_login_content .tabs {
        color: #999999;
        font-size: 17px;
        font-weight: bold;
        text-align: left;
    }
    .course_login_content .tabs .selected_tab {
        color: #333333;
        border-bottom: 3px solid #333333;
    }
    .course_login_content .tabs .tab_message_login {
        display: inline-block;
        padding-bottom: 3px;
    }
    .course_login_content .tabs .tab_psw_login {
        display: inline-block;
        margin-left: 30px;
        padding-bottom: 3px;
    }
    .message_login, .psw_login {
        margin-top: 50px;
        text-align: left;
    }
    .message_login .verification_code, .message_login .mobile_phone, .psw_login .user_name,  .psw_login .psw {
        display: inline-block;
        vertical-align: middle;
        width: 100%;
        height: 44px;
        margin-bottom: 15px;
        font-size: 0;
        white-space: nowrap;
    }
    .mobile_phone .select-code {
        display: inline-block;
        width: 60px;
        height: 100%;
        font-size: 16px;
        color: #333333;
        line-height: 44px;
        border-radius: 4px 0 0 4px;
        margin-right: -1px;
        vertical-align: top;
        min-width: 16px;
        text-align: center;
        text-shadow: 0 1px 0 white;
        border: 1px solid #ccc;
        white-space: nowrap;
    }
    .message_login .add-on, .psw_login .add-on {
        display: inline-block;
        width: 60px;
        height: 100%;
        background: none;
        font-size: 18px;
        font-weight: normal;
        line-height: 44px;
        border-radius: 4px 0 0 4px;
        margin-right: -1px;
        vertical-align: top;
        min-width: 16px;
        padding: 4px 5px;
        text-align: center;
        text-shadow: 0 1px 0 white;
        border: 1px solid #ccc;
        white-space: nowrap;
    }
    .message_login .add-on .fa, .psw_login .add-on .fa {
        display: inline-block;
        font: normal normal normal 14px/1 FontAwesome;
        font-size: inherit;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        transform: translate(0, 0);
    }
    .message_login .mobile_phone input, .psw_login input {
        width: calc(100% - 60px);
    }
    .message_login .verification_code input {
        width: calc(100% - 176px);
    }
    .message_login input, .psw_login input {
        display: inline-block;
        height: 44px;
        padding: 4px 12px;
        box-sizing: border-box;
        margin-bottom: 0;
        position: relative;
        -webkit-border-radius: 0 4px 4px 0;
        -moz-border-radius: 0 4px 4px 0;
        border-radius: 0 4px 4px 0;
        font-size: 14px;
        background-color: white;
        border: 1px solid #cccccc;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        -moz-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        -webkit-transition: border linear 0.2s, box-shadow linear 0.2s;
        -moz-transition: border linear 0.2s, box-shadow linear 0.2s;
        -o-transition: border linear 0.2s, box-shadow linear 0.2s;
        transition: border linear 0.2s, box-shadow linear 0.2s;
        line-height: 20px;
        color: #555555;
        outline-style: none ;
        text-shadow: none ;
        -webkit-appearance: none ;
        -webkit-user-select: text ;
        outline-color: transparent ;
    }
    .message_login input[class*="span"], .psw_login input[class*="span"] {
        float: none;
        margin-left: 0;
    }
    .message_login input:focus, .psw_login input:focus {
        border: 1px solid #78baee;
    }
    .message_login .btn_message_login, .psw_login .btn_psw_login {
        margin-top: 20px;
        width: 100%;
        height: 44px;
        background-color:#ff505a;
        line-height: 44px;
        color: white;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
    }
    .message_login .agreement {
        margin-top: 40px;
        color: #999999;
        font-size: 14px;
        text-align: center;
    }
    .message_login .agreement span {
        color: #ff505a;
    }
    .btn-up-resend {
        display: inline-block;
        width: 100px;
        height: 36px;
        font-size: 13px;
        color: #fff;
        background-color: #42c02e;
        border-radius: 20px;
        line-height: 36px;
        margin-left: 15px;
        text-align: center;
        text-decoration: none;
    }
    .btn_psw_bottom {
        height: 80px;
    }
    .disable {
        opacity: .5;
        pointer-events: none;
    }
</style>
